export enum OfferCenters {
    Disabled = 1,
    Pending = 2,
    Enabled = 3
  }
  